import { type FC, type PropsWithChildren } from 'react';

import styles from './LabelsLayout.css';

export const LabelsLayout: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles['labels-layout']}>{children}</div>;
};
